import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-facebook',
  templateUrl: 'facebook.html'
})
export class FacebookPage {

  client: any;
  event: any;
  dataSocial: any;
  isSpinner: any = true;

  constructor(public navCtrl: NavController, public params: NavParams) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.dataSocial = this.params.get('social');

    setTimeout(() => {
      this.isSpinner = false;
    }, 2000);
  }

}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-social/facebook/facebook.ts